// const API_URL = process.env.REACT_APP_API_URL_SIGA;

export const ServicesLogin = (values) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        menu: [
          {
            name: "Hemeroteca",
            path: "/hemeroteca",
          },
          {
            name: "Configuracion",
            path: "/configuracion",
          },
          {
            name: "Usuarios",
            path: "/usuarios",
          },
          
        ],
        user: "test@ycs.es",
      });
    }, 500); // simula un pequeño retardo de red
  });
};
